import { useState, useEffect } from 'react';
import { client } from '../api/client';
import { useAuth } from './useAuth';

export interface NotificationItem {
  id: number;
  title: string;
  body: string;
  is_read: boolean;
  created_at: string;
}

export function useNotifications() {
  const { isAuthenticated } = useAuth();
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setNotifications([]);
      setLoading(false);
      return;
    }

    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const response = await client.get<NotificationItem[]>('/push/notifications');
        setNotifications(response.data || []);
      } catch (err) {
        console.error('Failed to fetch notifications', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchNotifications();
  }, [isAuthenticated]);

  const markAsRead = async (id: number) => {
    // Optimistic update
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
    
    try {
      await client.post('/push/notifications/mark-read', { id });
    } catch (err) {
      console.error('Failed to mark notification as read', err);
      // Revert on error if needed
    }
  };

  const unreadCount = notifications.filter(n => !n.is_read).length;

  return { notifications, unreadCount, loading, markAsRead };
}
